import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import isWebview from '@gc-npm/utils.common.is-webview';
import isColApp from '@gc-npm/utils.common.is-colapp';
import getUUID from '@gc-npm/utils.monitoring.get-uuid';
const { PubSubConnector, PubSubService } = require("@gc-npm/gcp-services.pubsub");
const { OpenTelemetryConnector, TraceContext } = require('@gc-npm/gcp-services.open-telemetry');
import {
  LAYOUT_TYPES,
  PARAMS_DICTIONARY,
  ZONES_BY_HEADER,
  ZONES_IDS,
  SCREEN_TYPES,
  COMON_SPEED_ID,
  COMON_SPEED_ID_104,
  COMON_SPEED_ID_105,
  TAPON_TYPES,
  COL_APP_OPERATION_SUCCESS,
} from '@/utils/constants';



const uiStore = (state) => state.UI;

export const getScreenTypeByWidth = (width) => {
  if (typeof width !== 'number' || Number.isNaN(width)) {
    return null;
  }
  if (width < 820) {
    return SCREEN_TYPES.MOBILE;
  }
  if (width <= 1268) {
    return SCREEN_TYPES.TABLET;
  }
  return SCREEN_TYPES.DESKTOP;
};

function getCustomTimestamp(date = new Date()) {
  const pad = (n, width = 2) => String(n).padStart(width, '0');

  const year = date.getUTCFullYear();
  const month = pad(date.getUTCMonth() + 1);
  const day = pad(date.getUTCDate());

  const hours = pad(date.getUTCHours());
  const minutes = pad(date.getUTCMinutes());
  const seconds = pad(date.getUTCSeconds());

  const micro = pad(date.getUTCMilliseconds(), 3) + "000";

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${micro} UTC`;
}
export const sendPubSubMessage = async ({
  processId,
  endpoint = "https://www.movistar.es/fibra-y-movil/configurador/",
  state = "",
  stateMessage = "",
  context,
  userAgent = ''
} = {}) => {
  try {
    const finalProcessId = processId ?? getUUID('', '', false);
    const pubSubTopic = process.env.NEXT_PUBLIC_PUBSUB_TOPIC;
    if (!pubSubTopic) {
      return;
    }

    let configPubService = null;
    if (typeof window === 'undefined') {
      // Node runtime expects only the topic name.
      configPubService = new PubSubService(pubSubTopic);
    } else {
      const pubSubCollectorUrl = `${process.env.NEXT_PUBLIC_PUBSUB_COLLECTOR_HOST}${process.env.NEXT_PUBLIC_PUBSUB_COLLECTOR_PATH}`;
      configPubService = new PubSubService(pubSubCollectorUrl, pubSubTopic);
    }




  // const pubSubInput = selectedIds;
  // const pubSubOutput = "";
  // const pubSubTraceId = traceContext?.traceId
  const partyIdHash = context?.userIdPartyHash
  const ga = {
    client_id: context?.clientIDs?.ga,
    session_id: context?.clientIDs?.sessionId
  }

const objectToSend = {
  processId: finalProcessId,
  Traceparent:  TraceContext && TraceContext?.getActiveSpan()?.spanContext()?.traceId,
  traceId: TraceContext && TraceContext?.getActiveSpan()?.spanContext()?.traceId,
  endpoint,
  stateTimestamp: getCustomTimestamp(),
  customerProductTree: JSON.stringify({}),
  input: JSON.stringify({}),
  output: JSON.stringify({}),
  backVersion: `${process.env.NEXT_PUBLIC_VERSION_JS}--${new Date(parseInt(process.env.NEXT_PUBLIC_VERSION_JS, 36)).toISOString().slice(5,19)}`,
  state,
  stateMessage,
  partyIdHash,
  userAgent,
  ga: JSON.stringify(ga)
}
  console.log(`version ${objectToSend.backVersion}`)
  await configPubService.publish(objectToSend);
  } catch (error) {
    console.log(error)
  }
  
};

export const scrollToSection = (sectionTitle) => {
  const sectionDOM = document?.querySelector(`.section.${sectionTitle}`);
  if (sectionDOM) {
    // Posición del elemento en el documento
    const elementPosition = sectionDOM.getBoundingClientRect().top + window.scrollY;
    const offsetPosition = elementPosition - 80; // Ajustar por el desplazamiento deseado

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  }
};

export const getDurationPromoText = (promotions) => {
  let durationText = null;
  if (promotions && promotions.length > 0) {
    durationText = promotions[0].texts?.duration;
  }
  return durationText;
}

export const getUrlParams = () => {
  if (typeof window === 'undefined' || !window.location.search) {
    return null;
  }

  const raw = window.location.search.substring(1); // sin el "?"
  const urlParams = {};
  raw.split('&').forEach((pair) => {
    const [key, value = ''] = pair.split('=');
    if (PARAMS_DICTIONARY.includes(key)) {
      const decodedValue = decodeURIComponent(value);
      if (decodedValue.includes('+')) {
        urlParams[key] = decodedValue
          .split(/\s|%20|;/)
          .filter((group) => group !== '')
          .map((group) => group.split('+'));
      } else {
        urlParams[key] = decodedValue
          .split(/\s|%20|;/)
          .filter((item) => item !== '');
      }
    }
  });

  return Object.keys(urlParams).length ? urlParams : null;
};



export const getUrlParamsSelection = (urlParams, sessionZone) => {
  const paramsSelection = {
    ids: null,
    productOfferings: null,
  }

  const {
    productOffering,
    modulos,
    poTV,
    poN,
  } = urlParams || {};

  const businessZoneId = ZONES_IDS[sessionZone || ZONES_BY_HEADER.FREE];

  const ids2Select = [];
  const productOfferings2Select = [];

  if (productOffering && Array.isArray(productOffering) && productOffering.length > 0) {
    let id = productOffering[0];
    if (id && Array.isArray(id) && id.length > 0) {
      [(id)] = id;
    }
    productOfferings2Select.push({
      id,
      businessZoneId,
      characteristics: [
          {
            id: 13,
            value: urlParams?.speedId?.[0] || COMON_SPEED_ID,
          },
        ],
    });
  }
     const ensureNewConnectivityModules = (id) => {
          const [main, sub] = id.split('-');
          const num = parseInt(main, 10);
        
          // Solo modificar 100–105
          if (num >= 100 && num <= 105) {
          
            // Si ya viene con parte secundaria, lo dejamos como está
            if (sub) return id;
          
            // Casos especiales:
            if (num === 104) return `${main}-${COMON_SPEED_ID_104}`;
            if (num === 105) return `${main}-${COMON_SPEED_ID_105}`;
          
            // Para 100–103 → fallback
            return `${main}-3883`;
          }
        
          // 200+ u otros → no tocar
          return id;
      };
  if (modulos) {
    modulos.forEach((id) => {
      ids2Select.push(ensureNewConnectivityModules(id));
    })
  }

  if (poTV) {
    poTV.forEach((id) => {
      ids2Select.push(id);
    })
  }

  if (poN) {
    if (productOffering) {
      const [id, value] = poN[0].split('_');
      productOfferings2Select.push({
        id,
        characteristics: [
          {
            id: 43,
            value,
          },
        ],
        businessZoneId,
      });
    } else {
      poN.forEach((id) => {
        ids2Select.push(id);
      })
    }
  }

  if (ids2Select.length > 0) {
    paramsSelection.ids = ids2Select;
  }
  if (productOfferings2Select.length > 0) {
    paramsSelection.productOfferings = productOfferings2Select;
  }
  return paramsSelection;
}

export const getPrices = (layout, cart) => {
  const {
    price,
    promoPrice,
    instalationPrice,
    instalationPromoPrice,
    modulos,
  } = cart;

  const prices = {
    price,
    promoPrice: promoPrice !== price ? promoPrice : null,
    instalationPrice: instalationPrice || null,
    instalationPromoPrice: instalationPromoPrice !== instalationPrice
      ? instalationPromoPrice
      : null,
  }
  if (layout === LAYOUT_TYPES.CONECTIVIDAD) {
    prices.price = modulos?.conectividad.price;
    prices.promoPrice = modulos?.conectividad.promoPrice !== modulos?.conectividad.price
      ? modulos?.conectividad.promoPrice
      : null;
  } else if (layout === LAYOUT_TYPES.TV) {
    prices.price = modulos?.tv.price;
    prices.promoPrice = modulos?.tv.promoPrice !== modulos?.tv.price
      ? modulos?.tv.promoPrice
      : null;
  }
  return prices;
}

export const getCardTypesBySubSection = (cards) => {
  let someCardPromoted = false;
  let someCardHired = false;
  cards.forEach((eachCards) => {
    if (eachCards.hired) {
      someCardHired = true
    }
    if (eachCards.promoPrice && eachCards.promotions && eachCards.promotions.length > 0) {
      someCardPromoted = true
    }
  });
  return { someCardPromoted, someCardHired }
}

const getUnSubscribeNames = (modules) => {
  let unsubscribeNames = '';
  if (modules && Array.isArray(modules) && modules.length > 0) {
    const unsubscribeModules = modules.filter(
      (eachModule) => Boolean(eachModule.unsubscribe),
    );
    if (unsubscribeModules.length > 0) {
      unsubscribeNames = 'bajas:';
      unsubscribeModules.forEach((element, index) => {
        unsubscribeNames += `${index > 0 ? ';' : ''}${element?.logic?.alias || element?.title?.text}`;
      });
    }
  }

  return unsubscribeNames;
};

const getUpgradeModulesNames = (modules, clientModules, userType) => {
  let upgradeModulesNames = '';

  if (Array.isArray(modules) && modules.length > 0) {
    // elimina el "00" y normaliza ids
    const items = modules.filter((m) => String(m?.id).trim() !== '00');

    if (items.length > 0) {
      // clientModules viene como array de objetos { id, qty }
      const clientIds = new Set(
        (Array.isArray(clientModules) ? clientModules : [])
          .map((cm) => String(cm?.id ?? '').trim())
          .filter(Boolean)
      );

      let altas = items.filter((m) => !clientIds.has(String(m?.id ?? '').trim()));

      // si userType vacío, no filtra (comportamiento original)
      if (userType === '') {
        altas = items;
      }

      if (altas.length > 0) {
        upgradeModulesNames = 'altas:';
        altas.forEach((eachAlta, index) => {
          upgradeModulesNames += `${index > 0 ? ';' : ''}${eachAlta?.logic?.alias || eachAlta?.title?.text}`;
        });
      }
    }
  }

  return upgradeModulesNames;
};


export const getModuleNamesTagginInfo = (modules, layout, clientModules, userType) => {
  let moduleNamesTagginInfo = '';

  if (modules) {
    let modulesItems = modules[layout]?.items;
    if (layout === LAYOUT_TYPES.ALL) {
      const conectividadItems = modules[LAYOUT_TYPES.CONECTIVIDAD]?.items || [];
      const tvItems = modules[LAYOUT_TYPES.TV]?.items || [];
      modulesItems = [
        ...conectividadItems,
        ...tvItems,
      ]
    }
    const bajas = getUnSubscribeNames(modulesItems);
    const altas = getUpgradeModulesNames(modulesItems, clientModules, userType);

    if (bajas) {
      moduleNamesTagginInfo += bajas;
    }
    if (altas) {
      moduleNamesTagginInfo += moduleNamesTagginInfo ? `||${altas}` : altas;
    }
  }

  return moduleNamesTagginInfo;
};

// timeToRefresh en minutos
export const mustSendToRefresh = (ts, timeToRefresh) => {
  const timestamp = parseInt(ts, 10);
  if (isNaN(timestamp)) {
    return false;
  }

  const now = Date.now();
  const diffMs = now - timestamp;
  const minutesElapsed = Math.floor(diffMs / (1000 * 60));

  return minutesElapsed >= timeToRefresh;
}

export const getCenteredActiveId = (sectionIds, selectedId) => {
  const index = sectionIds.indexOf(selectedId);

  if (index === 0 || index === sectionIds.length - 1) {
    return selectedId; // mantener en su posición natural
  }

  return sectionIds[index - 1]; // mover una posición atrás para centrar
};

export const getLmelineToSelect = (lmeItems) => {
  const items = lmeItems?.items || [];
  const lineToSelect = items.find((item) => item.orderSubcategory === 1);
  const linesIds = items.map(({ id, quantity }) => ({ id, qty: quantity }));

  return { lineToSelect, linesIds };
}

const downloadDocument = async (document) => {
  if (document && document.url) {
    const { name, url } = document;
    if (isWebview() && window.webviewBridge) {
      try {
        const response = await fetch(url);
        const blob = await response.blob();
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64 = reader.result;
          const base64WithoutPrefix = base64.split(',')[1];
          window.webviewBridge.downloadBase64({
            contentInBase64: base64WithoutPrefix,
            fileName: `${name}.pdf`,
          });
        };
        reader.onerror = (e) => {
          console.error('Error leyendo blob como base64:', e);
        };
        reader.readAsDataURL(blob);
      } catch (error) {
        console.error(`Error al descargar o convertir: ${name}`, error);
      }
    } else {
      saveAs(url, `${name}.pdf`);
    }
  } else {
    console.log('No hay documento para procesar');
  }
};

export const downloadDocuments = async (documents, ZIP_NAME, DOWNLOAD_FILE_NAME) => {
  if (documents && Array.isArray(documents) && documents.length > 0) {
    if (documents.length === 1) {
      downloadDocument(documents[0]);
    } else {
      const zip = new JSZip();
      await Promise.all(
        documents.map(async ({ name, url }) => {
          if (url) {
            try {
              const response = await fetch(url);
              if (!response.ok) {
                throw new Error(`Error descargando el archivo ${name}`);
              }
              const blob = await response.blob();
              zip.file(`${name}.pdf`, blob);
            } catch (error) {
              console.log(error);
            }
          }
        }),
      );
      // Generar y descargar el ZIP
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        zip.generateAsync({ type: 'blob' }).then((blob) => {
          window.navigator.msSaveOrOpenBlob(blob, DOWNLOAD_FILE_NAME);
        });
      } else if (isWebview() && window.webviewBridge) {
        zip.generateAsync({ type: 'base64' }).then((base64) => {
          window.webviewBridge.downloadBase64({
            contentInBase64: base64,
            fileName: ZIP_NAME,
          });
        });
      } else {
        zip.generateAsync({ type: 'base64' }).then((base64) => {
          window.open(`data:application/zip;base64,${base64}`, ZIP_NAME);
        });
      }
    }
  } else {
    console.log('No hay documentos para procesar');
  }
};

export const parseArrayToDict = (inputArray) => {
  return inputArray.reduce((acc, item) => {
    if (!item.includes('_')) {
      return acc;
    }

    const [key, ...rest] = item.split('_');
    acc[parseInt(key)] = rest.join('_');
    return acc;
  }, {});
};

export const flattenObjectToKeyValueStrings = (object) => {
  return Object.entries(object).map(([key, value]) => {
    return `${key}_${value.replace(/^_/, '')}`; // Elimina "_" inicial si existe
  });
};

export const normalizeTitle = (text) => text
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/[^a-zA-Z0-9\s]/g, '')
  .replace(/\s+/g, ' ')
  .trim();


export const initOpenTelemetry = () => {
   if(!OpenTelemetryConnector.initialized) {
     const otelCollectorHost = process.env.NEXT_PUBLIC_OTEL_COLLECTOR_HOST
     const otelCollectorTracesPath = process.env.NEXT_PUBLIC_OTEL_COLLECTOR_TRACES_PATH;
     const otelCollectorMetricsPath = process.env.NEXT_PUBLIC_OTEL_COLLECTOR_METRICS_PATH;
     const otelCollectorLogsPath = process.env.NEXT_PUBLIC_OTEL_COLLECTOR_LOGS_PATH;
     const otelUserAgent = process.env.NEXT_PUBLIC_USER_AGENT;
     const spanLatenciesHistogramName = process.env.NEXT_PUBLIC_OTEL_SPAN_LATENCIES_HISTOGRAM_NAME;
     const spanCounterName = process.env.NEXT_PUBLIC_OTEL_SPAN_COUNTER_NAME;
     const tracePercentage = process.env.NEXT_PUBLIC_OTEL_TRACE_PERCENTAGE
       ? Number.parseInt(process.env.NEXT_PUBLIC_OTEL_TRACE_PERCENTAGE, 10)
       : 100;
     const projectName = process.env.NEXT_PUBLIC_PROJECT_ID;
     const serviceName = projectName;
     const projectVersion = process.env.NEXT_PUBLIC_VERSION_JS;

     if (!otelCollectorHost || !otelCollectorTracesPath || !otelCollectorMetricsPath || !projectName) {
       console.error("[OpenTeletry] Missing  env variables", process.env);
       return;
     }

     if (!projectVersion) {
       console.error("[OpenTelemetry] Missing project version in expo config");
       return;
     }
try {
   OpenTelemetryConnector.init({
       otelCollectorHost,
       otelCollectorTracesPath,
       otelCollectorMetricsPath,
       otelCollectorLogsPath,
       userAgent: otelUserAgent,
       spanLatenciesHistogramName,
       spanCounterName,
       projectName,
       projectVersion,
       serviceName,
       batchSpanProcessor: true,
       tracePercentage,
     });
} catch (error) {
  console.error(`[OpenTelemetry] error ${error}`);
       return;
}
    
   }
};
export const initPusSub = () => {
  const pubSubTopic = process.env.NEXT_PUBLIC_PUBSUB_TOPIC;
  if (!pubSubTopic) {
    return;
  }

  if (typeof window === 'undefined') {
    // Node runtime expects only the topic name.
    const maybePromise = PubSubConnector.initializePublisher(pubSubTopic);
    if (maybePromise?.catch) {
      maybePromise.catch((error) => console.error('[PubSub] init error', error));
    }
    return;
  }

  if(!PubSubConnector?.instance?.pubSubCollectorUrl) {
    const pubSubCollectorUrl = `${process.env.NEXT_PUBLIC_PUBSUB_COLLECTOR_HOST}${process.env.NEXT_PUBLIC_PUBSUB_COLLECTOR_PATH}`;
    PubSubConnector.initializePublisher(pubSubCollectorUrl, pubSubTopic);
  }
}

export const parseUserAgentInfo = (ua = '', isClient) => {
  // --- NOVUM ---
  const novumMatch = ua.match(/MovistarES\/(\d+\.\d+\.\d+)/i);
  if (novumMatch) {
    return `novum-${novumMatch[1]}`;
  }

  // --- COL APP ---
  const colMatch = ua.match(/col-app.*v(\d+\.\d+\.\d+)/i);
  if (colMatch) {
    return `col-app-${colMatch[1]}`;
  }

  // --- WEB ---
  return isClient ? 'web-client': 'web-no-client';
};

const getParentManhattanBridge = () => {
  // si el iframe padre es de otro origen, leer sus propiedades lanza SecurityError
  try {
    return window.parent?.manhattanBridge;
  } catch (error) {
    return undefined;
  }
};

const getManhattanBridgeMethod = (methodName) => {
  const bridge = [getParentManhattanBridge(), window.manhattanBridge]
    .find((candidate) => typeof candidate?.[methodName] === 'function');
  return bridge ? bridge[methodName].bind(bridge) : null;
};

// La app nativa vuelve a su home y refresca productos, dispositivos y notificaciones
export const notifyColAppOperationSuccess = () => {
  if (!isColApp()) {
    return;
  }
  const userOperationSuccess = getManhattanBridgeMethod('userOperationSuccess');
  if (!userOperationSuccess) {
    throw new ReferenceError('No existe manhattanBridge.userOperationSuccess', '/utils/index.js');
  }
  userOperationSuccess(COL_APP_OPERATION_SUCCESS);
};

export const getRulePromoted  = (main) => {
  if (typeof window !== 'undefined' && main && main?.x) {
    if(main?.x == '2' || main?.x == '4' || main?.x == '6') {
      return true
    }
  }
  return false
}

export const getTaponInfo = (isClient, status, reason) => {
  let info = TAPON_TYPES.NO_CLIENT;

  // ✅ PRIORIDAD: tapones por reason
  if (reason && isClient) {
    switch (reason) {
      case 'TAPON_FUSION_SIN_TV_FUTBOL':
        return TAPON_TYPES.CLIENT.FUSION_SIN_TV_FUTBOL;

      case 'TAPON_FUSION_CON_TV_FUTBOL':
        return TAPON_TYPES.CLIENT.FUSION_CON_TV_FUTBOL;

      default:
        break;
    }
  }

  // 🔁 Lógica actual (status técnico)
  if (status === '422') {
    info = TAPON_TYPES.CLIENT[422];
  } else {
    if (isClient) {
      info = TAPON_TYPES.CLIENT.ERROR_API;
    } else {
      info = TAPON_TYPES.NO_CLIENT;
    }
  }

  return info;
};
